'use strict';

import uuid from 'uuid';

/**
 * @property {String}        id        - unique string id
 * @property {String}        name      - unique name
 * @property {String}        email     - users' email (system only supports a single email)
 * @property {String}        role      - users' role within the system these can be only player or gm
 * @property {Array<String>} favorites - array of campaign-setting id's that are linked on the sidenav
 * @property {Object}        settings  - user settings bucket
 * @property {Date}          created   - timestamp of user creation
 * @property {Date}          modified  - timestamp of user update
 */
export default class User {
  /**
   * @param {String}        id
   * @param {String}        name
   * @param {String}        email
   * @param {String}        role
   * @param {Array<String>} favorites
   * @param {Object}        settings
   * @param {Date}          created
   * @param {Date}          modified
   */
  constructor(id, name, email, role, favorites, settings, created, modified) {
    this.id = id || uuid.v4();
    this.name = name || null;
    this.email = email || null;
    this.role = role || 'player';
    this.favorites = favorites || [];
    this.settings = settings || {};
    this.created = created || new Date();
    this.modified = modified || new Date();
  }
}